(function ($) {
    $(function () {
        $('.menu-item-has-children')
            .find('.dropdown-toggle')
            .attr('data-toggle', '');

        let body = $('body');
        let desktopMenuBreakpoint = 1100;

        /**
         * Add class to body when sticky header is showing
         */

        // on page load
        if (
            $(window).scrollTop() > 100 ||
            body.hasClass('search-results') ||
            body.hasClass('error404')
        ) {
            body.addClass('sticky-header');
            $('header').addClass('sticky');
        } else {
            body.removeClass('sticky-header');
            $('header').removeClass('sticky');
        }

        // on scroll
        if (!body.hasClass('search-results') && !body.hasClass('error404')) {
            $(window).scroll(function () {
                if ($(window).scrollTop() > 100) {
                    $('body').addClass('sticky-header');
                    $('header').addClass('sticky');
                } else {
                    $('body').removeClass('sticky-header');
                    $('header').removeClass('sticky');
                }
            });
        }

        /**
         * Mobile menu
         */

        // add/remove the no-scroll class
        $('header .navbar-toggler').on('click', function () {
            $('body').toggleClass('no-scroll');
        });

        // set the mobile headings on page load (when the page is loaded in mobile view)
        setMobileMenuheadings();

        // set the mobile headings on resize (when the page is resized from desktop to mobile view)
        $(window).on('resize', function () {
            setMobileMenuheadings();
        });

        function setMobileMenuheadings() {
            if (window.innerWidth < desktopMenuBreakpoint) {
                // on mobile -> add a <h3> title to the dropdown ul elements
                $('#navbarOrange')
                    .find(
                        '.navbar-nav .menu-item.menu-item-has-children > .dropdown-menu'
                    )
                    .each(function () {
                        $(this).addClass('mobile-menu-sub-level-panel');

                        let subLevelTitleElement = $('<h3>').html(
                            $(this).siblings('.nav-link').html().trim()
                        );

                        // only add the heading if it doesn't already exist
                        if (
                            $(this).find('.sub-level-panel-heading').length ===
                            0
                        ) {
                            $(this).prepend(
                                $('<li>')
                                    .addClass(
                                        'menu-item sub-level-panel-heading'
                                    )
                                    .append(subLevelTitleElement)
                            );
                        }
                    });
            } else {
                // on desktop remove the headings if they exist
                $('#navbarOrange')
                    .find(
                        '.navbar-nav .menu-item.menu-item-has-children > .dropdown-menu'
                    )
                    .each(function () {
                        if (
                            $(this).find('.sub-level-panel-heading').length > 0
                        ) {
                            $(this).find('.sub-level-panel-heading').remove();
                        }
                    });
            }
        }

        $('#navbarOrange.navbar-collapse')
            // when the mobile menu starts to open
            .on('show.bs.collapse', function () {
                // calculate and set the mobile-menu-height CSS variable
                let headerBannerHeight = 0;

                $('body > header')
                    .children()
                    .each(function () {
                        headerBannerHeight += $(this).outerHeight();
                    });

                if (!$('body > header').hasClass('sticky')) {
                    headerBannerHeight +=
                        parseInt($('html').css('margin-top')) -
                        $('html').scrollTop();
                }

                $(this).css(
                    '--mobile-menu-height',
                    $(window).outerHeight() - headerBannerHeight + 'px'
                );

                // add the curr-level class
                $(this).children('#menu-wrap').addClass('curr-level');

                // add the class nav-opening to the header
                $(this).closest('header').addClass('nav-opening');
                $(this).closest('header').removeClass('nav-close');
            })

            // when the mobile menu completes opening
            .on('show.bs.collapse', function () {
                $(this).closest('header').removeClass('nav-opening');
                $(this).closest('header').addClass('nav-open');
            })

            // when the mobile menu starts to close
            .on('hide.bs.collapse	', function () {
                $(this).closest('header').removeClass('nav-open');
                $(this).closest('header').addClass('nav-closing');
            })

            // when the mobile menu closes
            .on('hidden.bs.collapse', function () {
                $(this).find('.curr-level').removeClass('curr-level');

                $(this).find('.show').removeClass('show fade-in');

                $(this).find('.mobile-menu-sub-level-panel').scrollTop(0);

                $(this).find('.js-menu-back-btn').data('depth-level', 0);

                $(this).closest('header').removeClass('nav-closing');
                $(this).closest('header').addClass('nav-close');
            });

        let mobileMenuBackBtnWrap = $('#navbarOrange').find('.back-btn-wrap');
        let mobileMenuBackBtn =
            mobileMenuBackBtnWrap.children('.js-menu-back-btn');

        // initially set the depth-level data attribute of the back button to 0
        mobileMenuBackBtn.data('depth-level', 0);

        // when the back button is clicked
        mobileMenuBackBtn.on('click', function () {
            $(this).data('depth-level', $(this).data('depth-level') - 1);

            let currentMenuPanel = $('#navbarOrange').find(
                '.mobile-menu-sub-level-panel.curr-level'
            );

            currentMenuPanel
                .parent()
                .closest('.mobile-menu-sub-level-panel')
                .addClass('curr-level');

            currentMenuPanel
                .addClass('fade-out')
                .removeClass('show fade-in curr-level');

            if ($(this).data('depth-level') <= 0) {
                $('#navbarOrange').find('#menu-wrap').addClass('curr-level');

                $(this)
                    .data('depth-level', 0)
                    .parent()
                    .addClass('fade-out')
                    .removeClass('show fade-in');
            }
        });

        if (window.innerWidth < desktopMenuBreakpoint) {
            mobileMenuLevels();
        }

        $(window).on('resize', function () {
            if (window.innerWidth < desktopMenuBreakpoint) {
                mobileMenuLevels();
            }
        });

        function mobileMenuLevels() {
            // when a link with a dropdown is clicked
            $('#menu-wrap')
                .find(
                    '.navbar-nav .menu-item.menu-item-has-children > .nav-link'
                )
                .on('click', function (evt) {
                    evt.preventDefault();

                    $('#menu-wrap')
                        .find('.curr-level')
                        .removeClass('curr-level');
                    $('#menu-wrap').removeClass('curr-level');

                    // show its dropdown and add the curr-level class to it
                    $(this)
                        .siblings('.mobile-menu-sub-level-panel')
                        .scrollTop(0)
                        .removeClass('fade-out')
                        .addClass('show fade-in curr-level');

                    if (mobileMenuBackBtn.data('depth-level') === 0) {
                        mobileMenuBackBtnWrap
                            .removeClass('fade-out')
                            .addClass('show fade-in');
                    } else {
                        $(this)
                            .siblings('.mobile-menu-sub-level-panel')
                            .css(
                                'top',
                                $(this)
                                    .closest(
                                        '.mobile-menu-sub-level-panel, .header-navbar-menu-inner-wrap'
                                    )
                                    .scrollTop()
                            );
                    }

                    mobileMenuBackBtn.data(
                        'depth-level',
                        mobileMenuBackBtn.data('depth-level') + 1
                    );

                    return false;
                });
        }
    });
})(jQuery);
